module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-conseil-expert-du-jour-masque-carotte.533bad93.jpg";